import { render, staticRenderFns } from "./TeamSettings.vue?vue&type=template&id=6f2bab2d&"
import script from "./TeamSettings.vue?vue&type=script&lang=js&"
export * from "./TeamSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports